import { render, staticRenderFns } from "./PopUpGeneralDetailFile.vue?vue&type=template&id=3d2b4626&scoped=true&"
import script from "./PopUpGeneralDetailFile.vue?vue&type=script&lang=js&"
export * from "./PopUpGeneralDetailFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpGeneralDetailFile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PopUpGeneralDetailFile.vue?vue&type=style&index=1&id=3d2b4626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2b4626",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2b4626')) {
      api.createRecord('3d2b4626', component.options)
    } else {
      api.reload('3d2b4626', component.options)
    }
    module.hot.accept("./PopUpGeneralDetailFile.vue?vue&type=template&id=3d2b4626&scoped=true&", function () {
      api.rerender('3d2b4626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/docDigital/components/PopUpGeneralDetailFile.vue"
export default component.exports